// Module
var code = `<h4 style="text-align: center; margin-bottom: 10px" ng-if="captionText">
    {{ captionText }}
    <a href="{{ captionUrl }}" target="_blank" ng-if="captionUrl">
        <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
    </a>
</h4>
<br/>

<table class="table" ng-if="vm.rows.length > 0" fixed-table-headers="scrollable-area" ng-table>
    <tr>
        <th
            ng-repeat="key in vm.column_keys"
            uib-tooltip="{{ vm.tooltips[key] }}"
            tooltip-append-to-body="true"
        >{{ vm.titles[key] }}</th>
    </tr>
    <tr ng-repeat="row in vm.rows">
        <td ng-repeat="key in vm.column_keys">
            {{ row[key] }}
        </td>
    </tr>
</table>
`;
// Exports
module.exports = code;